import { get, post, smpGet, smpAxiosInstance } from "@/vue/api/api";
import { saveAs } from "file-saver";

export const bps = {
  state: {
    // BPS History
    bpsHistory: [],
    //BULK PREVALIDATION
    bpsPrevalidationResult: [],
    bpsPrevalidationStarted: {},
    bpsPrevalidationJobStatus: {},
    //BULK PROVISION
    bpsResult: [],
    bpsTempResult: [],
    bpsStarted: {},
    bpsJobStatus: {},
    bpsJobInput: [],

    snapshot: [],
    snapshotJobStatus: {},
    snapshotJobResult: [],
  },
  getters: {
    getBpsHistory: (state) => {
      return state.bpsHistory;
    },
    //bps prevalidation
    getBpsPrevalidationResult: (state) => {
      return state.bpsPrevalidationResult;
    },
    getBpsPrevalidationStarted: (state) => {
      return state.bpsPrevalidationStarted;
    },
    getBpsPrevalidationJobStatus: (state) => {
      return state.bpsPrevalidationJobStatus;
    },
    //bps provision
    getBpsResult: (state) => {
      return state.bpsResult;
    },
    getBpsTempResult: (state) => {
      return state.bpsTempResult;
    },
    getBpsStarted: (state) => {
      return state.bpsStarted;
    },
    getBpsJobStatus: (state) => {
      return state.bpsJobStatus;
    },
    getBpsJobInput: (state) => {
      return state.bpsJobInput;
    },

    getSnapshot: (state) => {
      return state.snapshot;
    },
    getSnapshotJobStatus: (state) => {
      return state.snapshotJobStatus;
    },
    getSnapshotJobResult: (state) => {
      return state.snapshotJobResult;
    },
  },
  mutations: {
    SET_BPS_HISTORY: (state, payload) => {
      state.bpsHistory = payload;
    },
    // bulk prevalidation
    SET_BPS_PREVALIDATION_RESULT: (state, payload) => {
      state.bpsPrevalidationResult = payload;
    },
    SET_BPS_PREVALIDATION_STARTED: (state, payload) => {
      state.bpsPrevalidationStarted = payload;
    },
    SET_BPS_PREVALIDATION_JOB_STATUS: (state, payload) => {
      state.bpsPrevalidationJobStatus = payload;
    },

    //bulk provision
    SET_BPS_RESULT: (state, payload) => {
      state.bpsResult = payload;
    },
    SET_BPS_TEMP_RESULT: (state, payload) => {
      state.bpsTempResult = payload;
    },
    SET_BPS_STARTED: (state, payload) => {
      state.bpsStarted = payload;
    },
    SET_BPS_JOB_STATUS: (state, payload) => {
      state.bpsJobStatus = payload;
    },
    SET_BPS_JOB_INPUT: (state, payload) => {
      state.bpsJobInput = payload;
    },
    //SNAPSHOT
    SET_SNAPSHOT: (state, payload) => {
      state.snapshot = payload;
    },
    SET_SNAPSHOT_JOB_STATUS: (state, payload) => {
      state.snapshotJobStatus = payload;
    },
    SET_SNAPSHOT_RESULT: (state, payload) => {
      state.snapshotJobResult = payload;
    },
  },
  actions: {
    fetchBpsHistory: ({ commit, rootGetters }, payload) => {
      get("/v1/bps/customer/" + rootGetters.getCustomer.cid + "/history")
        .then((response) => {
          console.log("fetchBpsHistory response");
          console.log(response);

          commit("SET_BPS_HISTORY", response.data);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchBpsHistory error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    //Bulk prevalidation
    bulkPrevalidate: ({ commit, rootGetters }, payload) => {
      // /v1/bps/customer/{customerId}/execute
      let body = {
        metadata: {
          uri:
            "https://platform.8x8.com/workflow/v1/customers/" +
            rootGetters.getCustomer.cid +
            "/users/create/prevalidation?source=CM",
          method: "POST",
          chunkSize: 1,
          continueOnError: true,
        },
        data: payload.data,
      };

      post("/v1/bps/customer/" + rootGetters.getCustomer.cid + "/execute", body)
        .then((response) => {
          console.log("bulkPrevalidate response");
          console.log(response);
          console.log(response.data);

          commit("SET_BPS_PREVALIDATION_STARTED", response.data);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("bulkPrevalidate error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchBpsPrevalidationJobStatus: ({ commit }, payload) => {
      //payload.data = jobs/{JOB}/executions/{EXECUTION}/status
      ///v1/bps/jobs/{JOB}/executions/{EXECUTION}/status
      get("/v1/bps/" + payload.data)
        .then((response) => {
          console.log("fetchBpsPrevalidationJobStatus response");
          console.log(response);
          console.log(response.data);

          commit("SET_BPS_PREVALIDATION_JOB_STATUS", response.data[0]);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchBpsPrevalidationJobStatus error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchBpsPrevalidationResult: ({ commit }, payload) => {
      //payload.data = jobs/{JOB}/results
      ///v1/bps/jobs/{JOB}/results
      ///v1/bps/jobs/{JOB}/executions/{EXECUTION}/status
      get("/v1/bps/" + payload.data)
        .then((response) => {
          console.log("fetchBpsPrevalidationResult response");
          console.log(response);
          console.log(response.data);

          commit("SET_BPS_PREVALIDATION_RESULT", response.data);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchBpsPrevalidationResult error");
          console.log(error.message);
          payload.error(error.message);
        });
    },

    //Bulk provision
    bulkProvison: ({ commit, dispatch, rootGetters }, payload) => {
      // /v1/bps/customer/{customerId}/execute
      let body = {
        metadata: {
          uri:
            "https://platform.8x8.com/workflow/v1/customers/" +
            rootGetters.getCustomer.cid +
            "/provision?source=CM",
          method: "POST",
          chunkSize: 1,
          continueOnError: true,
        },
        data: payload.data,
      };

      post("/v1/bps/customer/" + rootGetters.getCustomer.cid + "/execute", body)
        .then((response) => {
          console.log("bulkProvison response");
          console.log(response);
          console.log(response.data);

          commit("SET_BPS_STARTED", response.data);
          payload.success(response.message);
          //audit
          dispatch("sendAudit", {
            eventType: "CREATE",
            objectType: "BPS",
            details: body,
          });
        })
        .catch((error) => {
          console.log("bulkProvison error");
          console.log(error.message);
          payload.error(error.message);
        });
    },

    fetchBpsJobStatus: ({ commit }, payload) => {
      //payload.data = jobs/{JOB}/executions/{EXECUTION}/status
      ///v1/bps/jobs/{JOB}/executions/{EXECUTION}/status
      get("/v1/bps/" + payload.data)
        .then((response) => {
          console.log("fetchBpsJobStatus response");
          console.log(response);
          console.log(response.data);

          commit("SET_BPS_JOB_STATUS", response.data[0]);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchBpsJobStatus error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchBpsResult: ({ commit }, payload) => {
      //payload.data = jobs/{JOB}/results
      ///v1/bps/jobs/{JOB}/results
      ///v1/bps/jobs/{JOB}/executions/{EXECUTION}/status
      get("/v1/bps/" + payload.data)
        .then((response) => {
          console.log("fetchBpsResult response");
          console.log(response);
          console.log(response.data);
          if (payload.temp) {
            commit("SET_BPS_TEMP_RESULT", response.data);
          } else commit("SET_BPS_RESULT", response.data);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchBpsResult error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchBpsJobInput: ({ commit }, payload) => {
      //payload.data =
      ///https://platform.8x8.com/bulk/v1/jobs/\JOBID/inputdata
      // Vue.prototype.$http.defaults.headers.common['token'] = response.data.token;
      smpGet(payload.data)
        .then((response) => {
          console.log("fetchBpsJobInput response");
          console.log(response);

          commit("SET_BPS_JOB_INPUT", response.content);
          payload.success("success");
        })
        .catch((error) => {
          console.log("fetchBpsJobInput error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchBpsJobFile: ({ commit }, payload) => {
      //payload.data =
      ///https://platform.8x8.com/bulk/v1/jobs/\JOBID/inputdata
      // Vue.prototype.$http.defaults.headers.common['token'] = response.data.token;
      smpAxiosInstance
        .get(payload.data, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          console.log("fetchBpsJobFile");
          console.log(response);
          let blob = new Blob([response.data], { type: "application/csv" });
          saveAs(blob, "BpsJobInput.csv");
          payload.success("success");
        })
        .catch((error) => {
          console.log("fetchBpsJobFile error");
          console.log(error);
          payload.error(error.message);
        });
    },

    //SNAPSHOT_____________
    fetchSnapshot: ({ commit, rootGetters }, payload) => {
      //payload.data= /v1/customers/{CUSTOMER_ID}/snapshot
      get("/v1/customers/" + rootGetters.getCustomer.cid + "/snapshot")
        .then((response) => {
          console.log("fetchSnapshot response");
          console.log(response);
          console.log(response.data);

          commit("SET_SNAPSHOT", response.data);
          payload.success(response.message);
        })
        .catch((error) => {
          console.log("fetchSnapshot error");
          console.log(error.message);
          payload.error(error.message);
        });
    },
    fetchSnapshotJobStatus: ({ commit }, payload) => {},
    fetchSnapshotJobResult: ({ commit }, payload) => {},
  },
};
